import React from 'react';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { ISale } from 'gen/ApiClient';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, ISale> {}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
